module.exports = __webpack_public_path__ + "img/01-menu-bar-on_01.4c909084.png";